"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DecimalsConvert = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _ethTypes = require("@blockwell/eth-types");
var _chains = require("@blockwell/chains");
class DecimalsConvert {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "decimals");
    (0, _defineProperty2.default)(this, "label", "Decimals");
    (0, _defineProperty2.default)(this, "description", "Convert decimals from on-chain values.");
    (0, _defineProperty2.default)(this, "settings", {
      value: {
        type: "var",
        title: "Decimals",
        description: "Number of decimals to use.",
        variableType: ["contract", "value"],
        singleOnly: true,
        undefinedAuto: true
      }
    });
  }
  editorLabel(params) {
    if (!(params !== null && params !== void 0 && params.value)) {
      return "automatic";
    }
    if (params.value.type === "const") {
      var _params$value$param, _params$value$param$v;
      return (_params$value$param = params.value.param) === null || _params$value$param === void 0 ? void 0 : (_params$value$param$v = _params$value$param.value) === null || _params$value$param$v === void 0 ? void 0 : _params$value$param$v.toString();
    }
    return "from variable";
  }
  dependencies(context, params, resolver) {
    let decimals = null;
    if (params !== null && params !== void 0 && params.value) {
      decimals = resolver.resolveNumber(params.value);
    } else if (context.contract) {
      var _context$contract$par;
      if (context.contract.address === _ethTypes.ETH_ADDRESS_ZERO) {
        decimals = (0, _chains.getChain)(context.contract.network).decimals;
      } else if ((_context$contract$par = context.contract.parameters) !== null && _context$contract$par !== void 0 && _context$contract$par.decimals) {
        decimals = parseInt(context.contract.parameters.decimals);
        if (isNaN(decimals)) {
          decimals = 0;
        }
      }
    } else {
      var _contract$parameters;
      let contract = resolver.resolveContract();
      if (contract !== null && contract !== void 0 && (_contract$parameters = contract.parameters) !== null && _contract$parameters !== void 0 && _contract$parameters.decimals) {
        decimals = parseInt(contract.parameters.decimals);
      }
    }
    return decimals;
  }
  create(deps, batcher) {
    if (deps) {
      return value => {
        if (typeof value === "string" || typeof value === "number") {
          return new _bignumber.default(value).shiftedBy(deps * -1).toString(10);
        }
        return value;
      };
    } else {
      return null;
    }
  }
}
exports.DecimalsConvert = DecimalsConvert;
//# sourceMappingURL=DecimalsConvert.js.map